module.exports = __webpack_public_path__ + "static/marut-0b77a893bba0d2a4110f9c837421e524.png";